import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../pages/login/connect/Login";
import LoginAlert from "../LoginAlert/LoginAlert";
import ProgramSettings from "../../pages/ProgramSettings/ProgramSettings";
import EditProfileBusiness from "../../pages/EditProfileBusiness/EditProfileBusiness";
import { useUserInfo } from "../../pages/Profile/connect/User";
import { Badge } from 'antd';
function DesktopSidebar() {
  const [isShowAppSettingModal, setIsShowAppSettingModal] = useState(false);
  const [isShowAppEditProfileModal, setIsShowAppEditProfileModal] = useState(false);
  const { getUserInit } = useUserInfo((state) => state.actions)
  const messagesBadge = useUserInfo((state) => state.messagesBadge)
  const NotifsBadge = useUserInfo((state) => state.NotifsBadge)
  console.log({ messagesBadge });
  console.log({ NotifsBadge });

  useEffect(() => {
    getUserInit()
  }, [])
  const menuItems = [
    {
      id: 1,
      title: "اعلان ها",
      link: "/NotificationsPage",
      url: "menu-des-1.svg",
      badge: NotifsBadge
    },
    { id: 2, title: "پیام ها", link: "/Messages", url: "menu-des-2.svg", badge: messagesBadge },
    { id: 3, title: "تنظیمات برنامه", url: "menu-des-3.svg" },
    { id: 4, title: "ویرایش پروفایل", url: "menu-des-4.svg" },
    {
      id: 5,
      title: "مدیریت آگهی ها",
      link: "/AdManagement",
      url: "menu-des-5.svg",
    },
    {
      id: 6,
      title: "نشان ها و یادداشت شده ها",
      link: "/Shown",
      url: "menu-des-6.svg",
    },
    // { id: 7, title: "حراجی ها", link: "/Auctions", url: "menu-des-7.svg" },
    {
      id: 8,
      title: "کیف پول و پرداخت ها",
      link: "/Wallet",
      url: "menu-des-8.svg",
    },
    // { id: 8, title: "پلنر", link: "/Planner", url: "menu-des-9.svg" },
    {
      id: 9,
      title: "راهنما و پشتیبانی",
      link: "/VeeuHelp",
      url: "menu-des-10.svg",
    },
    {
      id: 10,
      title: "قوانین و مقررات",
      link: "/TermsAndConditions",
      url: "menu-des-11.svg",
    },
    { id: 11, title: "درباره ویو", link: "/AboutVeeu", url: "menu-des-12.svg" },
    {
      id: 12,
      title: "کاربران مسدود شده",
      link: "/BlackList",
      url: "blocekUsers.svg",
    },
  ];
  const convertToPersian = (num) => num && num.toLocaleString("fa-IR");
  return (
    <>
      <div className=" rounded-xl py-6 px-2 top-0 z-30 relative  col-span-1    h-screen sm:hidden md:hidden 2xl:col-span-1 ">
        <div className="flex flex-col gap-8 bg-white mt-12 fixed top-12 h-full overflow-auto">
          {menuItems.map((item) => (
            <div
              key={item.id}
              className="cursor-pointer w-full flex gap-3 items-center justify-start px-3 z-40 hover:font-bold transition-all bg-white"
            >
              <img
                src={
                  item.id === 12
                    ? `blocekUsers.svg`
                    : `/desktop/icons/${item.url}`
                }
                alt=""
              />
              {item.link ? (
                <Link className="text-gray-600" to={item.link}>
                  <div className="flex">
                    <p>{item.title}</p>
                    {/* {item?.badge > -1 && item?.badge !==null && <Badge className={` text-white border border-gray-300 p-2 px-[9px] rounded-full z-1 ${item.badge > 0 ? `bg-red-700` : `bg-gray-400`}  `}>{convertToPersian(item.badge)}</Badge>} */}

                    {item?.badge > -1 && item?.badge !== null && (
                      <Badge
                        // color={`${item.badge > 0 ? `bg-red-700` : `bg-gray-400`}`}
                        count={convertToPersian(item.badge)}
                        showZero
                        style={{ backgroundColor: item.badge > 0 ? '#b91c1c' : '#9ca3af' }}
                      />
                    )}
                  </div>

                </Link>
              ) : item.id == 3 ? (
                <p
                  onClick={() => setIsShowAppSettingModal(true)}
                  className="text-gray-600"
                >
                  {item.title}
                </p>
              ) : (
                <p
                  onClick={() => setIsShowAppEditProfileModal(true)}
                  className="text-gray-600"
                >
                  {item.title}
                </p>
              )}
            </div>
          ))}

          <div className="w-full flex items-center justify-center flex-col">
            <div className="w-full flex gap-3 my-1 items-center justify-center px-3">
              <img src="icons/eyeIcon.svg" alt="" />
              <p>بازدید امروز:</p>
              <p>478</p>
            </div>
            <div className="w-full flex gap-3 my-1 items-center justify-center px-3">
              <p>نسخه :</p>
              <p>v.1.1</p>
            </div>
          </div>
        </div>
      </div>

      {isShowAppSettingModal && (
        <div
          className={`fade-in modal z-50 fixed top-0 w-full h-screen flex items-center justify-center bg-[#8d8d8da1]`}
        >
          <div className="rounded-xl p-2 bg-white flex flex-col items-center justify-center gap-4 w-[70%] shadow-sm relative">
            <div className="flex items-end justify-end w-full p-2">
              <img
                onClick={() => setIsShowAppSettingModal(false)}
                src="/icons/close-black.svg"
                alt=""
              />
            </div>
            <ProgramSettings setIsShowAppSettingModal={setIsShowAppSettingModal} />
          </div>
        </div>
      )}

      {isShowAppEditProfileModal && (
        <div
          onClick={(e) => {
            if (
              e.target.className.includes(
                "style-for-close-on-outside-edit-profile"
              )
            ) {
              document.removeEventListener(
                "click",
                setIsShowAppEditProfileModal(false)
              );
            }
          }}
          className={`style-for-close-on-outside-edit-profile fade-in modal z-50 fixed top-0 w-full h-screen flex items-center justify-center py-4 bg-[#8d8d8da1]  `}
        >
          <div className="rounded-xl p-2 bg-white flex flex-col items-center justify-center gap-4 w-[80%] shadow-sm relative">
            <div className="flex items-end justify-end w-max p-2 mt-5 absolute left-8 top-3">
              <img
                className="cursor-pointer"
                onClick={() => setIsShowAppEditProfileModal(false)}
                src="/icons/close-black.svg"
                alt=""
              />
            </div>
            <EditProfileBusiness
              setIsShowEditProfileModal={setIsShowAppEditProfileModal}
              isShowAppEditProfileModal={isShowAppEditProfileModal}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default DesktopSidebar;
